// extracted by mini-css-extract-plugin
export default {"indicator-leave-shift-request__icon":"indicator-leave-shift-request__icon--xvYBL","indicatorLeaveShiftRequestIcon":"indicator-leave-shift-request__icon--xvYBL"};